var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import 'react';
import styled from 'styled-components';
import { linkStyle } from '../Link/styles';
export var StyledButtonLink = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n\n  background: none;\n  padding: 0;\n  text-align: left;\n  border: none;\n"], ["\n  ", ";\n\n  background: none;\n  padding: 0;\n  text-align: left;\n  border: none;\n"])), function (props) {
  return linkStyle(props);
});
var templateObject_1;